import React, { useState } from 'react';
import { UserType } from '../types/types';
import jwt_decode from 'jwt-decode';

export interface UserContextType {
  user: UserType | null,
  setUser: React.Dispatch<React.SetStateAction<UserType | null>>,
  logout: boolean,
  setLogout: React.Dispatch<React.SetStateAction<boolean>>,
}

export const UserContext = React.createContext<UserContextType>({} as UserContextType);

export function useUserContext() {
  const [user, setUser] = useState<UserType | null>(null);
  const [logout, setLogout] = useState(false);

  const userProfileFromCookies = JSON.parse(localStorage.getItem('userProfile') || '{}');
  const token = userProfileFromCookies?.token ? userProfileFromCookies.token.replace('Bearer ', '') : '';
  const decodedToken:any = token ? jwt_decode(token) : null;


  // Token expirated?
  if ((decodedToken?.exp && decodedToken.exp < (Date.now() / 1000))) {
    localStorage.setItem('userProfile', '{}');
    setUser(null);
  } else {
    // Hay token valido en cookie, setear usuario
    if (!user?._id && userProfileFromCookies?._id && !logout) {
      if (!user?._id && userProfileFromCookies?._id) setUser(userProfileFromCookies);
    }

    // Hay token valido en usuario, setear usuario
    if (!userProfileFromCookies?._id && user?._id && !logout) {
      if (!userProfileFromCookies?._id && user?._id) localStorage.setItem('userProfile', JSON.stringify(user));
    }
  }


  const time = 1 * 60 * 60 * 1000; //1hr

  // Check token every hour
  setInterval(() => {
    if ((decodedToken?.exp && decodedToken.exp < (Date.now() / 1000))) {
      setLogout(true);
    }
  }, time);

  if (logout) {
    setUser(null);
    localStorage.setItem('userProfile', '{}');
    setLogout(false);
  }

  return {
    user,
    setUser,
    logout,
    setLogout,
  };
}
